import PropTypes from 'prop-types';
import { getErrorsPropTypes, getFieldsPropTypes } from '../../../../basicEditor';

export const dataPropTypes = {
  code_benefits: PropTypes.string,
  code_add_benefits: PropTypes.string,
  name: PropTypes.string,
  rate_law_free: PropTypes.string,
};

export const errorsPropTypes = PropTypes.shape(getErrorsPropTypes(dataPropTypes));
export const fieldsPropTypes = PropTypes.shape(getFieldsPropTypes(dataPropTypes));
